<template>
<!--修改密码对话框-->
  <el-dialog width="600px" title="修改密码" :visible.sync="dialogFormVisible" label-width="100px" destroy-on-close append-to-body>
    <div class="formBox">
    <el-form style="width: 400px" :model="form" :rules="rules" ref="form" class="demo-ruleForm" size="medium">
      <div class="formBox">
        <el-form-item label="旧密码" prop="oldPassword" style="width: 400px">
          <el-input type="password" v-model="form.oldPassword" autocomplete="off" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword" style="width: 400px">
          <el-input type="password" v-model="form.newPassword" autocomplete="off" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass" style="width: 400px">
          <el-input type="password" v-model="form.checkPass" autocomplete="off" maxlength="18"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :loading="submitLoading">提交</el-button>
      <el-button @click="resetForm">重置</el-button>
    </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "updatePassword",
  data () {
    var validateOld = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入旧密码'))
      }
      else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      dialogFormVisible: false,
      form: {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      },
      rules: {
        oldPassword:[
          { validator: validateOld, trigger: 'blur'},
          { min: 6, max: 18, message:'密码在6~18位之间', trigger: 'change'}
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    init() {
      this.dialogFormVisible = true;
      this.form = {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      }
    },

    submitForm() {  //提交修改请求
      this.$refs.form.validate((valid) => {
        if (valid) {
          let format_submit = {  //统一传参格式
            id: this.$store.state.userInfo.id,
            oldPass: this.form.oldPassword,
            newPass: this.form.newPassword
          }
          this.$confirm("即将修改密码，是否继续？","提示",{
            type: "info"
          }).then(()=>{
            this.submitLoading = true
            this.$axios.post("/users/change_password", format_submit).then((res) => {
              if (res.data.code === 200) {
                this.$message.success("修改成功！");
                this.dialogFormVisible = false;
              }
              else {
                this.$message.error(res.data.msg);
              }
              this.submitLoading = false
            }).catch((err) => {
              if (err.response.status === 500) {
                this.$message.error("网络异常，请稍后重试！");
              }
              else {
                this.$message.error("系统繁忙，请稍后重试！");
              }
              this.submitLoading = false
            })
          }).catch((err)=>{
            this.$message.info("取消修改！")
          })
        }
        else {
          this.$message.error("修改失败！");
          return false;
        }
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.form = {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      }
    }
  }
}
</script>

<style scoped>
  .formBox{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
